<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row>
              <el-col :md="10" :lg="10">
                <el-input :rows="1" placeholder="多个货号之间使用英文逗号 ',' 分隔" v-model="params.item_bns" clearable size="small">
                  <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
                </el-input>
              </el-col>
              <el-col :md="10" :lg="10">
                <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="download">导出</el-button>
              </el-col>
            </el-row>
            <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                <el-table-column prop="id" label="活动ID" width="90"></el-table-column>
                <el-table-column prop="title" label="活动名称" width="260"></el-table-column>
                <el-table-column prop="number" label="全平台适用" width="90">
                  <template slot-scope="scope">
                    {{ scope.row.use_all_shops_flag ? '是' : '否' }}
                  </template>
                </el-table-column>
                <el-table-column prop="item_bn" label="商品货号" width="90"></el-table-column>
                <el-table-column prop="item_name" label="商品名称"></el-table-column>
                <!-- <el-table-column prop="name" label="店铺名称"></el-table-column> -->
                <!-- <el-table-column prop="area_market_price" label="SKU售价" width="120">
                  <template slot-scope="scope">
                    ￥{{ scope.row.sku_price / 100 }}
                  </template>
                </el-table-column> -->
                <el-table-column prop="begin_time" label="开始时间">
                  <template slot-scope="scope">
                    {{ scope.row.begin_time | datetime('yyyy-MM-dd hh:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column prop="end_time" label="结束时间">
                  <template slot-scope="scope">
                    {{ scope.row.end_time | datetime('yyyy-MM-dd hh:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column prop="activeList" label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" @click="toActivity(scope.row.id)">查看活动</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="content-center content-top-padded">
              <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[20,50,100,200,500]"
                  :total="total_count"
                  :page-size="params.pageSize">
              </el-pagination>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import { preBuyonesfreeones, buyonesfreeonesExport } from '@/api/goods'
export default {
    data() {
      return {
        loading: false,
        params: {
          page: 1,
          pageSize: 20,
          item_bns: '',
        },
        total_count: 0,
        list: [],
      }
    },
    methods: {
      download() {
        buyonesfreeonesExport(this.params).then(res => {
          if (res.data.data.status == true) {
            window.location.href = res.data.data.url
            this.$message.success('导出成功')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      getItemSkuInfo() {
        this.loading = true
        console.log(this.params)
        preBuyonesfreeones(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      goodsSearch() {
        this.params.page = 1
        this.getItemSkuInfo()
      },
      handleSizeChange(pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getItemSkuInfo()
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num
        this.getItemSkuInfo()
      },
      // 跳转到活动详情
      toActivity(activity_id) {
        this.$router.push({path: '/marketing/buyonesfreeones/buyonesfreeones_editor/' + activity_id})
        this.$router.push({path: this.matchHidePage('editor/') + row.limit_id, query: {copy_flag: true}})
      },
    },
    mounted() {
      this.getItemSkuInfo()
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?05363a48